angular = require('angular')

app = angular.module('workflow.app')

overlayWrapper = undefined

app.run ($document, $rootScope) ->
  overlayWrapper = angular.element('<div class="overlay-wrapper"></div>')
  $document.find('body').append(overlayWrapper)

  # This is (unfortunately) for test where we want to cleanup between tests
  $rootScope.$on '$destroy', ()->
    overlayWrapper.remove()

app.directive 'overlay', ($document) ->
  transclude: 'element'
  link: (scope, element, attrs, noRequiredController, transclude) ->
    overlay = angular.element('<div class="overlay"></div>')

    transclude scope, (clone) ->
      overlay.append(clone)
      overlayWrapper.append(overlay)

    scope.$on '$destroy', () ->
      overlay.remove()

require('./OverlayTaggingToolbar')
